<template>
  <div
    class="flex w-auto grow-0 justify-center rounded-full border border-gray-200 px-2-5 text-center text-xxs"
    data-cy="lf-pill"
    :style="bgStyle"
    :class="[
      {
        'py-2': size === 'md',
        'py-1': size === 'sm',
      },
      pillClass,
    ]"
  >
    <div
      class="flex place-self-center overflow-hidden"
      :style="colorIndex != null ? textStyle : { color: '#868d9c' }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, useAttrs } from "vue";

import { getPillStyle } from "@/helpers/UI";
import { COLORS } from "@/helpers/constants";

const props = defineProps({
  colorIndex: {
    type: [String, Number],
    default: null,
  },
  opaque: {
    type: Boolean,
    default: false,
  },
  scorecard: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "md",
  },
});

const attrs = useAttrs();

const pillStyles = computed(() =>
  getPillStyle({
    color: COLORS[Number(props.colorIndex)],
    opaque: props.opaque,
  })
);

const bgStyle = computed(() => {
  if (props.colorIndex === null) {
    if (props.scorecard) {
      return { backgroundColor: "#F1F4F7" };
    }
    return { backgroundColor: "white" };
  }

  return {
    backgroundColor: pillStyles.value.backgroundColor,
    borderStyle: pillStyles.value.borderStyle,
  };
});

const textStyle = computed(() => {
  return {
    color: pillStyles.value.color,
  };
});

const pillClass = computed(() => {
  return (attrs as { class: string })?.class?.includes("font-")
    ? ""
    : "font-medium";
});
</script>
